import { render, staticRenderFns } from "./RememberPassword.vue?vue&type=template&id=13586f3f&"
import script from "./RememberPassword.vue?vue&type=script&lang=js&"
export * from "./RememberPassword.vue?vue&type=script&lang=js&"
import style0 from "./RememberPassword.vue?vue&type=style&index=0&id=13586f3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports